// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1QiDI","left":"StickyBox_left__yCO_W","right":"StickyBox_right__mcK1e"};